import { CountryCodeEnum } from "@/lib/enum/country-code.enum";
import { PageOrderEnum } from "@/lib/enum/pageOrder.enum";
import thgService from "@/services/thg/services/thgService";
import { ThgThgControllerFindAllPaginatedParamsGen, ThgThgViewModelGen } from "@/services/thg/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { ImpactTypeEnum } from "@/views/thg/enum/impact-type.enum";
import { Action, Module, getModule } from "vuex-module-decorators";
import { ThgStatusEnum } from "../enum/thg/thg-status.enum";
import { FilterTypes, IPaginationFilterListElement } from "./base-pagination.store";
import {
  BackwardsCompatibleDataAccessLayer,
  BackwardsCompatiblePaginatedStore
} from "../backwards-compatible-paginated.store";
import { PageDataHandler } from "@/lib/utility/data/page-data-handler";

export const ThgDataAccessLayer = new BackwardsCompatibleDataAccessLayer<ThgThgViewModelGen>();

@Module({
  dynamic: true,
  namespaced: true,
  name: "thgPagination",
  store
})
export class ThePaginationStore extends BackwardsCompatiblePaginatedStore<
  ThgThgViewModelGen,
  ThgThgControllerFindAllPaginatedParamsGen
> {
  _data = ThgDataAccessLayer;
  _pager = new PageDataHandler(this._data, this._pageProvider);

  protected _pageOrder: PageOrderEnum = PageOrderEnum.DESCENDING;
  protected _itemsPerPage = 100;
  protected _totalPages = 0;
  protected _paginationList: ThgThgViewModelGen[] = [];
  protected _currentPage = 1;
  protected _totalItems = 0;
  protected _isLoadAll = true;

  filterOptions: IPaginationFilterListElement[] = [
    { key: "registration.identificationnumber", type: FilterTypes.STRING },
    { key: "_id", type: FilterTypes.OBJECT_ID },
    { key: "numberplate", type: FilterTypes.STRING },
    { key: "timestamp.created", type: FilterTypes.DATE },
    { key: "_id", type: FilterTypes.OBJECT_ID },
    { key: "userId", type: FilterTypes.OBJECT_ID },
    { key: "partnerId", type: FilterTypes.OBJECT_ID },
    { key: "status", type: FilterTypes.ENUM, config: { items: Object.values(ThgStatusEnum) } },
    {
      key: "countryCode",
      type: FilterTypes.ENUM,
      config: { items: Object.values(CountryCodeEnum) }
    },
    {
      key: "impactType",
      type: FilterTypes.ENUM,
      config: { items: Object.values(ImpactTypeEnum) }
    },
    { key: "impactFactor", type: FilterTypes.NUMBER },
    { key: "code", type: FilterTypes.STRING },
    { key: "campaign", type: FilterTypes.STRING },
    { key: "year", type: FilterTypes.NUMBER },
    { key: "isBillingInformationComplete", type: FilterTypes.BOOLEAN },
    { key: "registration.identificationnumber", type: FilterTypes.STRING },

    { key: "isMultiyear", type: FilterTypes.BOOLEAN },
    { key: "registration.firstname", type: FilterTypes.STRING },
    { key: "registration.name", type: FilterTypes.STRING },
    { key: "registration.street", type: FilterTypes.STRING },
    { key: "registration.zipCode", type: FilterTypes.STRING },
    { key: "registration.city", type: FilterTypes.STRING },
    { key: "registration.huYear", type: FilterTypes.STRING },
    { key: "registration.huMonth", type: FilterTypes.STRING },
    { key: "registration.manufacturerNameCode", type: FilterTypes.STRING },
    { key: "registration.manufacturerTypeCode", type: FilterTypes.STRING },
    { key: "registration.driveTyp", type: FilterTypes.STRING },
    { key: "registration.numberplate", type: FilterTypes.STRING },
    { key: "registration.firstregistrationDay", type: FilterTypes.STRING },
    { key: "registration.firstregistrationMonth", type: FilterTypes.STRING },
    { key: "registration.firstregistrationYear", type: FilterTypes.STRING },
    { key: "registration.manufacturerName", type: FilterTypes.STRING },
    { key: "registration.manufacturerType", type: FilterTypes.STRING },
    { key: "registration.vehicleClass", type: FilterTypes.STRING }
  ];
  @Action
  protected async loadDocuments(query: ThgThgControllerFindAllPaginatedParamsGen): Promise<any> {
    return thgService.getAllThgsPaginated(query);
  }
}

export const ThgPaginationModule = getModule(ThePaginationStore);
